import type { Activity, IntegrationHealth, Lead, Persona } from '../types';

export function visibleLeads(persona: Persona, source: Lead[]): Lead[] {
  if (persona.role === 'manager') return source;
  if (persona.role === 'sdr') return source.filter((lead) => lead.sdrId === persona.id);
  if (persona.role === 'new_sales') return source.filter((lead) => lead.sellerId === persona.id);
  return [];
}

export function visibleActivities(persona: Persona, source: Activity[]): Activity[] {
  return persona.role === 'manager' ? source : source.filter((item) => item.actorId === persona.id);
}

export function visibleIntegrations(persona: Persona, source: IntegrationHealth[]): IntegrationHealth[] {
  if (persona.role === 'manager') return source;
  return source
    .filter((item) => item.eligibleSellerIds ? item.eligibleSellerIds.includes(persona.id) : !item.sellerId || item.sellerId === persona.id)
    .map((item) => ({
      ...item,
      name: item.eligibleSellerIds ? 'Acesso Multicanal compartilhado' : item.sellerId ? 'Minha sessao Multicanal' : item.name,
      message: item.eligibleSellerIds ? 'Leads deste acesso so entram no seu painel apos atribuicao' : item.sellerId ? 'Status da sua automacao supervisionada' : item.message,
      pending: item.sellerId === persona.id ? item.pending : 0,
    }));
}

export function canViewManagement(persona: Persona): boolean {
  return persona.role === 'manager';
}

